import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useState } from "react";
import machineFallbackImage from "../../../assets/machine-example.png";

import IconButton from "@mui/material/IconButton";
import FactoryIcon from "mdi-react/FactoryIcon";

import { Popover, Tooltip } from "@mui/material";
import { Theme247 } from "../../../styles/Theme247";
import { ApplyStyle as _s } from "../../../utils/ApplyStyle";
import CheckboxField from "./Checkbox";
import { truncateWithEllipses } from "../../../utils/helpers";

const MenuItemComponentEP = (props) => {
  const [anchorEl, setanchorEl] = useState(null);

  const handleClick = (event) => {
    setanchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setanchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleCheckbox = (
    event,
    isChecked,
    value,
    parentValue,
    checkTypeValue
  ) => {
    if (checkTypeValue == "machine" && isChecked == true) {
      var filterParent = props.checkedEPools.filter((a) => a == parentValue);
      if (filterParent == 0) {
        filterParent = props.subscribingNodeIds.filter(
          (a) => a.child == parentValue
        );
        if (filterParent == 0) {
          props.ReceivesubscribingNodeIds(
            value,
            parentValue,
            checkTypeValue,
            isChecked
          );
        }
      }
    } else if (checkTypeValue == "pool" && isChecked == true) {
      //  props.RemoveChild(value)
      props.ReceivesubscribingNodeIds(
        value,
        parentValue,
        checkTypeValue,
        isChecked
      );
    }

    //unsubscribe

    /*  else if (checkTypeValue == 'machine' && isChecked == false) {
       var filterParent = props.checkedEPools.filter(a => a == parentValue)
       if (filterParent == 0) {
         filterParent = props.subscribingNodeIds.filter(a => a.child == parentValue)
         if (filterParent == 0) {
           props.ReceivesubscribingNodeIds(value, parentValue,checkTypeValue,isChecked)
         }
       }
     } */
    else if (checkTypeValue == "pool" && isChecked == false) {
      // props.RemoveChild(value)
      props.ReceivesubscribingNodeIds(
        value,
        parentValue,
        checkTypeValue,
        isChecked
      );
    }

    //console.log(isChecked, value, parentValue, checkTypeValue);
  };
  var allPoolsChecked = false;

  //const filtered_pool = props.saeData[0].data[0].legalentity.hasequipmentpool.filter(s => s.equipmentpool.nodeid == props.item.equipmentpool.nodeid)
  const CheckMachineSubscription = (machinenodeid) => {
    if (props.subscribedEquipments[machinenodeid] !== undefined) {
      return true;
    } else {
      return false;
    }
    /* if (filtered_pool.length > 0) {
      const filteredMachine = filtered_pool[0].equipmentpool.hasequipment.filter(m => m.equipment.nodeid == machinenodeid);
      if (filteredMachine.length > 0) {
        return true;
      }
      else {
        return false
      }


    } */
  };
  //check either pool is subscribed or not

  const CheckPoolSubscription = (poolnodeid) => {
    if (props.subscribedEquipmentpools[poolnodeid] !== undefined) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className={"profileCustomMenu"}>
      <div className="image">
        <FactoryIcon size={50} />
      </div>
      <Tooltip title={props.item.equipmentpool.name}>
        <div className="text">
          {truncateWithEllipses(props.item.equipmentpool.name, 15)}
        </div>
      </Tooltip>

      <div className="actionButton">
        {" "}
        <IconButton onClick={handleClick}>
          <ArrowDropDownIcon />
        </IconButton>
      </div>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        className="customMenuPopOver"
      >
        <div className={"checkBoxWithText"}>
          <div className="innerMenuText">{props.item.equipmentpool.name}</div>
          <div>
            {props.subscribedEquipmentpools[props.item.equipmentpool.nodeid] !==
            undefined ? (
              ((allPoolsChecked = true),
              props.PoolsFromChildToParent(props.item.equipmentpool.nodeid),
              (
                <CheckboxField
                  nodeid={props.item.equipmentpool.nodeid}
                  onChange={handleCheckbox}
                  ischecked={true}
                  parent={0}
                  checkType={"pool"}
                />
              ))
            ) : (
              <CheckboxField
                nodeid={props.item.equipmentpool.nodeid}
                onChange={handleCheckbox}
                ischecked={false}
                parent={0}
                checkType={"pool"}
              />
            )
            /* (props.saeData[6]?.data.length > 0 ? (CheckPoolSubscription(props.item.equipmentpool.nodeid)?(
                    allPoolsChecked = true,
                    props.PoolsFromChildToParent(props.item.equipmentpool.nodeid),
                    <CheckboxField
                        nodeid={props.item.equipmentpool.nodeid}
                        onChange={handleCheckbox}
                        ischecked={true}
                        parent={0}
                        checkType={'pool'}
                    />

                    
              ):( allPoolsChecked = false,
                <CheckboxField
                    nodeid={props.item.equipmentpool.nodeid}
                    onChange={handleCheckbox}
                    ischecked={false}
                    parent={0}
                    checkType={'pool'}
                />))
                 : (<CheckboxField
                nodeid={props.item.equipmentpool.nodeid}
                onChange={handleCheckbox}
                ischecked={false}
                parent={0}
                checkType={'pool'}
              />)) */
            }
          </div>
        </div>

        {//machine
        props.item.equipmentpool.hasequipment &&
          props.item.equipmentpool.hasequipment.map((y, k) => {
            return (
              <div className={"checkBoxWithText"}>
                <div className={_s(Theme247.levelMenu.imageContainer)}>
                  <img
                    src={
                      y.equipment.image != null &&
                      y.equipment.image.fileid != ""
                        ? y.equipment.image.url
                        : machineFallbackImage
                    }
                    onError={(event) => {
                      event.currentTarget.onerror = null;
                      event.currentTarget.src = machineFallbackImage;
                    }}
                    alt="Machine Name"
                  />
                </div>
                <div className="innerMenuText">{y.equipment.name}</div>
                <div>
                  {allPoolsChecked == true
                    ? ""
                    : /* <CheckboxField
                    nodeid={y.equipment.nodeid}
                    onChange={handleCheckbox}
                    ischecked={true}
                    parent={props.item.equipmentpool.nodeid}
                    checkType={'machine'}
                  /> */

                    CheckMachineSubscription(y.equipment.nodeid)
                    ? ""
                    : /* <CheckboxField
                    nodeid={y.equipment.nodeid}
                    onChange={handleCheckbox}
                    ischecked={true}
                    parent={props.item.equipmentpool.nodeid}
                    checkType={'machine'}
                  /> */
                      "" /* <CheckboxField
                          nodeid={y.equipment.nodeid}
                          onChange={handleCheckbox}
                          ischecked={false}
                          parent={props.item.equipmentpool.nodeid}
                          checkType={'machine'}
                        /> */}
                </div>
              </div>
            );
          })}
      </Popover>
    </div>
  );
};

export default MenuItemComponentEP;
